import React, { useState } from "react";
import StatusPill from "../../../../components/data-table/StatusPill";
import RowActions from "../../../../components/data-table/RowActions";

// components
import { useDeleteNewsMutation } from "../../../../store/Reducer/news";
import DeleteModal from "../../../../components/confirm-dialog/delete-modal";
import MessageModal from "../../../../components/Modal/message-modal";

export default function TableBodyCustom({ data, index, onEditRow }) {
  const [isOpen, setIsOpen] = useState(false);
  const [messageModal, setMessageModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [deleteNews] = useDeleteNewsMutation(); // Hook to call deleteNews API

  const openModal = (id) => {
    setSelectedId(id); // Store the selected ID for deletion
    setIsOpen(true);
  };
  const closeModal = () => setIsOpen(false);

  const openMessageModal = () => setMessageModal(true);
  const closeMessageModal = () => setMessageModal(false);

  const handleDelete = async () => {
    if (selectedId) {
      try {
        await deleteNews(selectedId).unwrap(); // Call the deleteNews function with the ID
        closeModal(); // Close the modal after deletion
      } catch (error) {
        console.error("Failed to delete news:", error);
      }
    }
  };

  return (
    <>
      <tr className="hover:bg-gray-50">
        <td className="px-4 py-3">
          <div className="flex items-center gap-3 max-md:flex-row-reverse">
            {data?.file?.url ? (
              <img src={data.file.url} alt="" className="h-10 w-14 shrink-0 rounded-md object-cover" />
            ) : (
              <span className="h-10 w-14 shrink-0 rounded-md bg-gray-100" aria-hidden="true" />
            )}
            <button type="button" onClick={openMessageModal} className="text-left font-medium text-gray-900 hover:text-blue-700" title="Read the news">
              {data?.title}
            </button>
          </div>
        </td>
        <td className="px-4 py-3">
          {data?.links?.length ? (
            <div className="flex flex-wrap gap-x-3 gap-y-1">
              {data.links.map((link, idx) => (
                <a key={idx} href={link} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                  Link {idx + 1}
                </a>
              ))}
            </div>
          ) : (
            <span className="text-gray-400">—</span>
          )}
        </td>
        <td className="px-4 py-3">
          {data?.isActive === false && data?.isPublished ? (
            <StatusPill tone="gray">Hidden</StatusPill>
          ) : data?.isPublished ? (
            <StatusPill tone="green">Published</StatusPill>
          ) : (
            <StatusPill tone="gray">Draft</StatusPill>
          )}
        </td>
        <td className="px-4 py-3">
          <RowActions onEdit={() => onEditRow(data)} onDelete={() => openModal(data._id)} editLabel="Edit news" deleteLabel="Delete news" />
        </td>
      </tr>

      <DeleteModal
        isOpen={isOpen}
        title="Are You Sure?"
        desc="This record will be permanently deleted. This action cannot be undone."
        onConfirm={handleDelete}
        onCancel={closeModal}
      />

      <MessageModal
        isOpen={messageModal}
        data={data?.details}
        title="Message Details"
        onCancel={closeMessageModal}
      />
    </>
  );
}
